var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50005 7.5H15M15 7.5L12.5 10M15 7.5L12.5 5M10.5 12.5V14C10.5 15 9.77762 15.5 9 15.5L2.83333 15.5001C2.47971 15.5001 2.14057 15.3596 1.89052 15.1096C1.64048 14.8595 1.5 14.5204 1.5 14.1667V1.83342C1.5 1.47979 1.64048 1.14066 1.89052 0.890607C2.14057 0.640559 2.47971 0.500083 2.83333 0.500083C2.83333 0.500083 8.27378 0.5 9 0.5C9.72622 0.5 10.5 1 10.5 2L10.5 2.50003",
    stroke: "#67726D",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/LogOut.c9328c19051f7a3bf99deb73d1d0ba42.svg";
export { ForwardRef as ReactComponent };